var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    'py-2 px-4 uppercase focus:outline-none transition inline-flex items-center justify-center',
    _vm.variantClasses[_vm.variant] || _vm.variantClasses['primary'],
    _vm.sizeClasses[_vm.size] ],attrs:{"to":_vm.to,"href":_vm.href},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }